import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import addAuditAgencyDialog from './dialog.addAuditAgencyDialog';
import agency from './agency';
import controller from './agencies.controller';
import directive from './agencies.directive';

export default angular.module('app.components.advisory.auditTrail.agencies', [
  addAuditAgencyDialog,
  agency,
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive('amAgencies', directive)
  .controller('AgenciesController', controller)
  .name;

console.log('app.components.advisory.auditTrail.agencies created');
